import React, { useEffect, useState } from "react";
import OtherLayout from "../components/Layout/OtherLayout";
import blogBG from "../images/blogs/blog.jpg";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import TalkToExpert from "../components/LandingPage/TalkToExpert";

// Icons
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import FacebookIcon from '@mui/icons-material/Facebook';
import PinterestIcon from '@mui/icons-material/Pinterest';

import "./Blog.css";

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  document.title = `High Mountains - Blog`;
  const navigate = useNavigate();

  useEffect(() => {
    const getAllBlog = async () => {
      try {
        const res = await axios.get("api/blog/get-all-blog");
        const allBlogs = res.data.data.reverse(); // latest first for main grid
        setBlogs(allBlogs);
      } catch (err) {
        console.log(err);
      }
    };
    getAllBlog();
  }, []);

  const calculateReadingTime = (text) => {
    const wordsPerMinute = 200;
    const wordCount = text?.trim().split(/\s+/).length || 0;
    return Math.ceil(wordCount / wordsPerMinute);
  };

  // 🔹 Create a separate array for the oldest 5 blogs for banner
  const oldestFive = [...blogs].reverse().slice(0, 5);

  return (
    <>
      <OtherLayout background={blogBG}>
        {/* BLOG BANNER SECTION */}
      {/* BLOG BANNER SECTION */}
<div className="blogpage-banner">
  {oldestFive.length >= 5 && (
    <div className="blogpage-banner-grid">
      {/* Big Left Image */}
      <div
        className="blogpage-banner-item big"
        onClick={() =>
          navigate(`/blog/${oldestFive[0].title.replace(/\s+/g, "-")}`)
        }
      >
        <img
          src={`https://highmountains.in/blogImages/${oldestFive[0].image}`}
          alt={oldestFive[0].title}
        />
        <div className="blogpage-banner-overlay">
          <h3>{oldestFive[0].title}</h3>
        </div>
      </div>

      {/* Right Side Images */}
      <div className="blogpage-banner-right">
        {/* Top Two */}
        <div className="blogpage-banner-row">
          {oldestFive.slice(1, 3).map((item, i) => (
            <div
              key={i}
              className="blogpage-banner-item small"
              onClick={() =>
                navigate(`/blog/${item.title.replace(/\s+/g, "-")}`)
              }
            >
              <img
                src={`https://highmountains.in/blogImages/${item.image}`}
                alt={item.title}
              />
              <div className="blogpage-banner-overlay">
                <h4>{item.title}</h4>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Two */}
        <div className="blogpage-banner-row">
          {oldestFive.slice(3, 5).map((item, i) => (
            <div
              key={i}
              className="blogpage-banner-item small"
              onClick={() =>
                navigate(`/blog/${item.title.replace(/\s+/g, "-")}`)
              }
            >
              <img
                src={`https://highmountains.in/blogImages/${item.image}`}
                alt={item.title}
              />
              <div className="blogpage-banner-overlay">
                <h4>{item.title}</h4>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )}
</div>


        {/* BLOG GRID SECTION (latest first) */}
        <div className="blog-display-container">
          <div className="blog-display">
            <div className="row">
              {blogs.map((item, index) => (
                <div
                  key={index}
                  className="col-12 col-md-6 col-lg-4 mb-4"
                  onClick={() =>
                    navigate(`${item.title.replace(/\s+/g, "-")}`)
                  }
                >
                  <div className="blog">
                    <img
                      src={`https://highmountains.in/blogImages/${item.image}`}
                      alt={item.title}
                      className="blog-img"
                    />
                    <div className="blog-content">
                      <h5>{item.title}</h5>
                      <span>
                        {new Date(item.createdAt).toLocaleString("default", {
                          month: "long",
                          day: "numeric",
                        })}{" "}
                        | {calculateReadingTime(item.description)} min Read
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* SIDEBAR */}
          <aside className="more-blogs">
            {/* SOCIAL MEDIA LINKS */}
            <div className="social-media-links">
              <h6>Follow Us</h6>
              <div className="blog-page-social__media__links">
                <a href="https://instagram.com/highmountainsin" target="_blank" rel="noopener noreferrer" className="instagram">
                  <InstagramIcon /> Instagram
                </a>
                <a href="https://wa.me/919888823721" target="_blank" rel="noopener noreferrer" className="whatsapp">
                  <WhatsAppIcon /> WhatsApp
                </a>
                <a href="https://in.linkedin.com/company/highmountains" target="_blank" rel="noopener noreferrer" className="linkedin">
                  <LinkedInIcon /> LinkedIn
                </a>
                <a href="https://www.youtube.com/@highmountainsin" target="_blank" rel="noopener noreferrer" className="youtube">
                  <YouTubeIcon /> YouTube
                </a>
                <a href="https://www.facebook.com/Highmountains.in/" target="_blank" rel="noopener noreferrer" className="facebook">
                  <FacebookIcon /> Facebook
                </a>
                <a href="#" target="_blank" rel="noopener noreferrer" className="pinterest">
                  <PinterestIcon /> Pinterest
                </a>
              </div>
            </div>

            {/* TRENDING BLOGS */}
            <h5 className="mb-3">Trending Blogs</h5>
            {blogs.filter((item) => item.trending === true).length === 0 ? (
              <p>No trending blogs available.</p>
            ) : (
              blogs
                .filter((item) => item.trending === true)
                .slice(0, 10)
                .map((item, index) => (
                  <div
                    key={index}
                    className="recent-blog"
                    onClick={() =>
                      navigate(`/${item.title.replace(/\s+/g, "-")}`)
                    }
                  >
                    <div className="recent-blog-img">
                      <img
                        src={`https://highmountains.in/blogImages/${item.image}`}
                        alt={item.title}
                      />
                    </div>
                    <div className="recent-blog-content">
                      <h6>{item.title}</h6>
                      <span>
                        {new Date(item.createdAt).toLocaleString("default", {
                          month: "long",
                          day: "numeric",
                        })}
                      </span>
                    </div>
                  </div>
                ))
            )}
          </aside>
        </div>
      </OtherLayout>
    </>
  );
};

export default Blog;
